import React from 'react';
import type { PrivateBulkActionProps } from './types';
import { StyledButtonIcon } from './styles';
import { MAX_SUBJECT_GROUP_SIZE } from 'venn-utils';
import { useNavigateToStudio } from 'venn-components';
import { privateFundSubject, privatePortfolioSubject } from 'venn-state';
import { noop } from 'lodash';

export const AddToReportLab = ({ items, onComplete }: PrivateBulkActionProps) => {
  const subjects = items.map((item) =>
    item.itemType === 'PORTFOLIO' ? privatePortfolioSubject(item.id) : privateFundSubject(item.id),
  );

  const navigate = useNavigateToStudio('add to report lab library button', 'REPORT');

  const onClick = () => {
    navigate(subjects);
    onComplete('Add to Report Lab', noop);
  };

  return (
    <StyledButtonIcon
      onClick={onClick}
      iconType="file-chart-column"
      iconFontSize={20}
      text={`Add to Report Lab (${items.length})`}
      className="qa-navigate-to-reportlab"
      disabled={items.length > MAX_SUBJECT_GROUP_SIZE}
      tooltip={
        items.length > MAX_SUBJECT_GROUP_SIZE ? `Please select ${MAX_SUBJECT_GROUP_SIZE} investments or less` : ''
      }
    />
  );
};
